import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { I18n } from '@fiverr-private/fiverr_context';
import { ControlledCheckbox, RadioGroup, Range, CheckboxGroup, PairSelect } from '../content/filters';
import SelectContainer from '../content/SelectContainer';
import SwitchContainer from '../../SwitchContainer';
import { FILTER_TYPES, FILTERS_EXTRAS_PROPS, FILTERS_DISPLAY } from './consts';
import './index.scss';

const filtersComponentsMap = {
    [FILTER_TYPES.PRO]: SwitchContainer,
    [FILTER_TYPES.TOGGLE]: SwitchContainer,
    [FILTER_TYPES.CHECKBOX]: ControlledCheckbox,
    [FILTER_TYPES.INPUT_RANGE]: Range,
    [FILTER_TYPES.RADIO]: RadioGroup,
    [FILTER_TYPES.CHECKBOX_GROUP]: CheckboxGroup,
    [FILTER_TYPES.AUTO_COMPLETE]: SelectContainer,
    [FILTER_TYPES.MULTI_PAIRS_SELECT]: PairSelect
};

const inlineFilters = [FILTER_TYPES.TOGGLE, FILTER_TYPES.PRO];

class Filter extends React.Component {

    constructor(props) {
        super(props);
        this.clear = this.clear.bind(this);
    }

    clear(id, value = null) {
        const { onClear } = this.props;
        onClear(id, value);
    }

    render() {
        const { value, filter, additionalProps, onChange } = this.props;
        const { showTitle = true } = additionalProps;
        const { display_type: filterType, id: filterId } = filter;
        const displayType = FILTERS_DISPLAY[filterId] ? FILTERS_DISPLAY[filterId] : filterType;

        const RenderedFilter = filtersComponentsMap[displayType];

        if (!RenderedFilter) {
            return null;
        }

        const extraProps = FILTERS_EXTRAS_PROPS[filterType] || {};
        const containerClassNames = classNames({ 'inline-content': inlineFilters.includes(displayType) });
        const mergedProps = {
            ...extraProps,
            ...additionalProps
        };

        return (
            <div className={containerClassNames}>
                {showTitle &&
                    <header>
                        <h5>{filter.alias}</h5>
                        {extraProps.showClear &&
                            <span onClick={() => this.clear(filterId)}><I18n k="general.clear"/></span>
                        }
                    </header>
                }
                <RenderedFilter value={value}
                    {...filter}
                    {...mergedProps}
                    onChange={onChange}
                    onClear={this.clear}/>
            </div>
        );
    }
}

Filter.propTypes = {
    value: PropTypes.any,
    filter: PropTypes.object.isRequired,
    additionalProps: PropTypes.object,
    onChange: PropTypes.func,
    onClear: PropTypes.func
};

Filter.defaultProps = {
    additionalProps: {},
    onChange: () => true,
    onClear: () => true
};

export default Filter;
